import {getJSONP, processSolrPrograms} from '@nl/neu';
import {
	GET_FAV_TEAM, GET_FAV_TEAM_PROGRAMS_START, GET_FAV_TEAM_PROGRAMS, RESET_FAV_TEAM,
} from '../constants';

const getFavTeamAction = (teamIds) => (
		{
			type: GET_FAV_TEAM,
			teamIds,
		}
);

const resetFavTeamAction = () => (
	{
		type: RESET_FAV_TEAM,
	}
);

const getFavTeamProgramsAction = (programs, pageNumber, paging) => (
		{
			type: GET_FAV_TEAM_PROGRAMS,
			programs,
			pageNumber,
			paging,
		}
);

const getFavTeamSolrFeedUrl = (teamIds, solrProgramPrefix, pageSize, pageNumber) => {
	const q = teamIds.map((teamId) => (`%22${teamId.toLowerCase()}%22`));
	const solrQuery = `tagsExact:(${q.join('%20')})`;
	const startIndex = pageNumber !== 1 ? Math.round((pageNumber - 1) * pageSize) : 0;
	const feedUrl = `${solrProgramPrefix}usersearch?q=*:*&fq=${solrQuery}&rows=${pageSize}&start=${startIndex}&sort=score%20desc,releaseDate%20desc&fl=sequence,pid,name,description,seoName,runtime,releaseDate,releaseDateLocal,beginDateTime,beginDateTimeLocal,purchaseTypeId,showTitle,seasonTitle,image,programCode,extUrl,episode,location,venue,eventId,tvRating,progType,masterImage,catId,catSEOName,cat&wt=json&json.wrf=[cb]`;
	return feedUrl;
};

const getFavTeamProgramsPaging = (solrDataResponse, pageSize, pageNumber) => {
	const paging = {};
	paging.pageSize = pageSize;
	paging.totalCount = solrDataResponse.numFound;
	if (solrDataResponse.numFound > solrDataResponse.docs.length) {
		paging.totalPages = Math.ceil(solrDataResponse.numFound / pageSize);
	} else {
		paging.totalPages = 1;
	}
	paging.hasNextPage = paging.totalPages > pageNumber;
	return paging;
};

export const getFavTeam = (pageNumber = 1, callback) => (dispatch, getState) => {
	const {client: {data: {hasPs}},
		config: {data: {content: {programs}, PROGRAM_PAGE_SIZE}}, favteam} = getState();
	if (hasPs) {
		if (favteam.teamIds !== null) {
			const feedUrl = getFavTeamSolrFeedUrl(favteam.teamIds, programs,
					PROGRAM_PAGE_SIZE, pageNumber);
			dispatch({type: GET_FAV_TEAM_PROGRAMS_START, pageNumber});
			getJSONP(feedUrl, (solrData) => {
				dispatch(getFavTeamProgramsAction(processSolrPrograms(solrData.response.docs),
						pageNumber,
						getFavTeamProgramsPaging(solrData.response, PROGRAM_PAGE_SIZE, pageNumber)));
				const totalPage = Math.ceil(solrData.response.numFound / PROGRAM_PAGE_SIZE);
				callback && callback(solrData.response.docs, {totalPage});
			});
		} else {
			window.ps.favorite.list(null, {type: 'team', ps: 5000}, (data) => {
				const teamIds = data.contents.map((item) => (item.id));
				if (teamIds.length > 0) {
					dispatch(getFavTeamAction(teamIds));
					const feedUrl = getFavTeamSolrFeedUrl(teamIds, programs,
						PROGRAM_PAGE_SIZE, pageNumber);
					dispatch({type: GET_FAV_TEAM_PROGRAMS_START, pageNumber});
					getJSONP(feedUrl, (solrData) => {
						dispatch(getFavTeamProgramsAction(processSolrPrograms(solrData.response.docs),
								pageNumber,
								getFavTeamProgramsPaging(solrData.response, PROGRAM_PAGE_SIZE, pageNumber)));
						const totalPage = Math.ceil(solrData.response.numFound / PROGRAM_PAGE_SIZE);
						callback && callback(solrData.response.docs, {totalPage});
					});
				} else {
					dispatch(getFavTeamProgramsAction([],
							1,
							{pageSize: PROGRAM_PAGE_SIZE, totalCount: 0, totalPages: 1, hasNextPage: false}));
					callback && callback();
				}
			});
		}
	}
};

export const resetFavTeam = () => (dispatch) => {
	dispatch(resetFavTeamAction());
};
